export const FOUR_WEEK_MINIMUM_PRICE_THRESHOLD = 2;